import { combineReducers } from "redux";
import loginReducer from "./login.reducer";
import appReducer from "./app.reducer";
import cartReducer from "./cart.reducer";
export default combineReducers({
  loginReducer,
  appReducer,
  cartReducer,
});
